import { format, parseISO, isValid } from "date-fns"

export function formatDate(dateString: string | null | undefined): string {
  if (!dateString) return "—"
  const parsed = parseISO(dateString)
  if (!isValid(parsed)) return "—"
  return format(parsed, "yyyy-MM-dd 'at' HH:mm")
}
